module.exports = __webpack_public_path__ + "img/cJrrlRCk.060a13d1.svg";